<template>
    <div id="home-tab" class="home-tab" :class="{'no-tab': hideTab}">
        <NavTab :linkArr="linkArr" v-show="!hideTab"/>

        <div class="content-wrap ht-scroll-vertical" ref="contentWrap">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>

          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
    </div>
</template>

<script>
    import {sysVariable} from "@/utils/sys-variable"
    import {scrollBehavior, resumeScrollTop, resetScrollTop} from "@/utils/commons"
    import NavTab from '@/components/NavTab/NavTab'

    export default {
        name: 'HomeTab',
        components: {NavTab},
        data() {
            return {
                showServiceHall: false,
                showIssuedTask: false,
            }
        },
        computed: {
            hideTab() {
                return this.$route.name === 'ISSUED_TASK' && !this.showIssuedTask
            },
            linkArr() {
                const linkArr = []
                linkArr.push({to: {path: '/homeTab/myItems/receive', text: '我收到的'}})
                linkArr.push({to: {path: '/homeTab/myItems/send', text: '我发出的'}})
                linkArr.push({to: {path: '/homeTab/myTransfer'}, text: '我转办的'})
                if (this.showIssuedTask) linkArr.push({to: {path: '/homeTab/issuedTask'}, text: '填报任务'})
                return linkArr
            },
        },
        created() {
          sysVariable('mobile_servicehall_tab_config').then(resp => {
                if (typeof resp == 'string') resp = JSON.parse(resp)
                this.showServiceHall = resp.showHome||false
                this.showIssuedTask = resp.showYBT||false
            }).finally(() => {
                scrollBehavior(this.$el.id, this.$refs.contentWrap)
            })
        },
        beforeRouteUpdate(to, from, next) {
            resetScrollTop(this.$el.id, this.$refs.contentWrap)
            next()
        },
        beforeRouteEnter(to, from, next) {
            next(vm => resumeScrollTop(vm.$el.id, vm.$refs.contentWrap))
        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    .home-tab {
        border-radius: 6px;
        overflow: hidden;

        .content-wrap {
            height: calc(100vh - 54px);
        }

        &.no-tab {
            .content-wrap {
                height: 100vh;
                padding-top: 10px;
                box-sizing: border-box;
            }
        }
    }
</style>
